import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { MainUserService } from './main-user.service';

@Injectable({
  providedIn: 'root',
})
export class MainUserGuardService implements CanActivate {
  private readonly mainUserService: MainUserService = inject(MainUserService);

  public async canActivate(): Promise<boolean> {
    return firstValueFrom(this.mainUserService.isMainUserForCurrentCustomer());
  }
}

